import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApsServiceService } from '../aps-service.service';

@Component({
  selector: 'app-shopproduct',
  templateUrl: './shopproduct.component.html',
  styleUrls: ['./shopproduct.component.css']
})
export class ShopproductComponent implements OnInit {
  data:any;

  constructor(private router: Router ,private searchitem: ApsServiceService) { }

  ngOnInit(): void {
    this.searchitem.getProductitemsShop().subscribe((responce)=>{
    

      //console.log(responce,'products')
      this.data=responce.data


    })

  }

}
